import { jsx } from "react/jsx-runtime";
import { getSiteCssVariables } from "@wix/tpa-style-webpack-plugin/standalone";
import { TPAComponentsProvider } from "@wix/wix-ui-tpa/cssVars";
import { SITE_COLORS, SITE_TEXT_PRESETS } from "./theme.js";
const StyleProvider = ({ children }) => {
  const siteCssVariables = getSiteCssVariables(SITE_COLORS, SITE_TEXT_PRESETS);
  return /* @__PURE__ */ jsx("div", { style: siteCssVariables.variables, children: /* @__PURE__ */ jsx(TPAComponentsProvider, { value: {}, children }) });
};
export {
  StyleProvider
};
//# sourceMappingURL=style-provider.js.map
